import React, { Component } from "react";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Row,
    Col
} from "reactstrap";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import NumberFormat from 'react-number-format';
import 'react-datepicker/dist/react-datepicker.css';
const headerStyle = {
    padding: '0.5rem',
};
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import { confirmAlert } from 'react-confirm-alert';

class ViewThanhToan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {}
        };
    }
    handleSoTienChange = (obj, v) => {
        const floatValue = v.floatValue;
        let { item } = this.state
        if (floatValue >= 0) {
            item.SoTienThanhToan = floatValue
            this.setState({ item });
        }
    }
    handleSaveData = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                let { item } = this.state
                return (
                    <div className='custom-ui'>
                        <h1>THÔNG BÁO?</h1>
                        <p>Bạn muốn thanh toán với số tiền <span className="text-danger">{item.SoTienThanhToan}</span> không?
                    </p>
                        <button className="text-danger" onClick={() => {
                            this.props.ThanhToanCongNo(item);
                            onClose()
                        }}>Đồng ý</button>
                        <button onClick={onClose}>Hủy bỏ</button>
                    </div>
                )
            }
        });

    }
    numberOnclick = (e) => {
        e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
    }
    closePopupHandle = () => {
        this.props.onClose();
        this.setState({
            item: {}
        });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen) {
            this.setState({
                item: nextProps.item
            })
        }
    }
    render() {
        const {
            isRequesting,
            errors,
            messages
        } = this.props
        const { item } = this.state
        return (
            <div className="animated fadeIn">
                <Modal isOpen={this.props.isOpen} className={'modal-md'}>
                    <ModalHeader style={headerStyle}>THANH TOÁN CÔNG NỢ</ModalHeader>
                    <ModalBody>
                        <BlockUi tag="div" blocking={isRequesting}>
                            <div className="row">
                                <div className="col-sm-12 mb-2">
                                    <span className="text-red">{item.TenNhanVien}</span>
                                </div>
                                <div className="col-sm-12">
                                    <FormGroup className="mb-0">
                                        <Label htmlFor="soluong">Số tiền thanh toán</Label>
                                        <NumberFormat
                                            name={"SoTienThanhToan"}
                                            value={item.SoTienThanhToan || 0}
                                            defaultValue={1}
                                            thousandSeparator={"."}
                                            decimalSeparator={","}
                                            type="tel"
                                            onClick={this.numberOnclick.bind(this)}
                                            onValueChange={this.handleSoTienChange.bind(this, item)}
                                            className={"form-control order-input-sl price"} />
                                    </FormGroup>
                                </div>
                                <div className="col-sm-12">
                                    {item.No < item.Co ? <label className='text-danger'>Nhân viên đang thừa tiền, có thể không cần nhập</label> : ''}
                                </div>
                            </div>
                        </BlockUi>
                        <Row>
                            <Col md="12">
                                {!isRequesting && !!errors.length && (
                                    <Errors errors={errors} />
                                )}
                                {!isRequesting && !!messages.length && (
                                    <Messages messages={messages} />
                                )}
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleSaveData}><i className="fa fa-save"></i>&nbsp;Thanh toán</Button>
                        <Button color="secondary" onClick={this.closePopupHandle.bind(this)}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
export default ViewThanhToan


// WEBPACK FOOTER //
// ./src/views/CongNoNhanVien/_ViewThanhToan.js